// components/data-sources/connectorCatalog/tileState.ts

import type { ConnectorTileState, ManagedSourceConnector } from "@/types/managedSources";

/** A tile that starts a setup flow when clicked. */
export function isActivatable(state: ConnectorTileState): boolean {
  return state === "available" || state === "enabled_by_grant";
}

/** The connector's tile state; a backend without the field means `available`. */
export function tileStateOf(connector: ManagedSourceConnector): ConnectorTileState {
  return connector.tile_state ?? "available";
}

/**
 * "14 Oct 2026". English on purpose (customer-facing UI is English), and a
 * date only: the time of a request says nothing the customer acts on.
 */
export function formatRequestDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

/** The label a request tile carries. */
export function requestTileLabel(
  state: ConnectorTileState,
  requestedAt: string | null | undefined
): string | null {
  if (state === "on_request") return "Available on request";
  if (state === "requested") {
    const date = formatRequestDate(requestedAt);
    return date ? `Requested on ${date}` : "Requested";
  }
  return null;
}
